import { render, staticRenderFns } from "./CasaDetails.vue?vue&type=template&id=0bc2ff88&scoped=true"
import script from "./CasaDetails.vue?vue&type=script&lang=js"
export * from "./CasaDetails.vue?vue&type=script&lang=js"
import style0 from "./CasaDetails.vue?vue&type=style&index=0&id=0bc2ff88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2ff88",
  null
  
)

export default component.exports